import { z } from "zod";

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  // Public — bot username for Telegram deep links. Defaults to the prod
  // bot so local/preview deployments don't fail validation.
  VITE_TELEGRAM_BOT_USERNAME: z.string().min(1).default("finally_meetup_bot"),
});

const parsed = envSchema.safeParse(import.meta.env);
if (!parsed.success) {
  throw new Error(
    `Missing environment variables:\n${parsed.error.issues.map((i) => `  ${i.path}: ${i.message}`).join("\n")}`,
  );
}

export const env = parsed.data;
